// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';
import Row from '../../components/Row';
import Column from '../../components/Column';

const otherS = {
  Banner: styled(Row)`
		height: 118px;
		position: relative;
		background: #EF8200 0% 0% no-repeat padding-box;
		padding: 0px 106px;
		display: flex;
		align-items: center;
	`,
  HomeWrapper: styled(Row)`
		width: 100%;
		bold 24px/36px Noto Sans TC;
		letter-spacing: 0.38px;
		color: #444444;
	`,
  Container: styled(Column)`
		width: 1083px;
		padding: 14px 244px 0px 236px;
	`,
  BreadcrumbWrapper: styled(Row)`
		margin-left: -60px;
	`,
  BreadcrumbText: styled.span`
    font-weight: 500;
    font-size: 18px;
    line-height: 32px;
		letter-spacing: 0.29px;
		color: #646464;
		margin-right: 5px;
	`,
  BreadcrumbArrow: styled.img`
		transform: rotate(270deg);
		margin: 0 10px;
	`,
  Title: styled.div`
    font-weight: 700;
    font-size: 24px;
    line-height: 36px;
		letter-spacing: 0.38px;
		color: #444444;
		margin-top: 67px;
		margin-bottom: 30px;
	`,
  Paragraph: styled.p`
    font-weight: 300;
    font-size: 18px;
    line-height: 32px;
		letter-spacing: 0.29px;
		color: #444444;
	`,
  Sidebar: styled(Column)`
		width: 357px;
		border-left: 1px solid #DFDFDF;
		height: 100vh;
		padding: 80.5px;
	`,
  TocTitle: styled.div`
		font: 18px/32px Noto Sans TC;
		letter-spacing: 0.29px;
		color: #575757;
		margin-left: 6.5px;
		cursor: pointer;
		border-bottom: 1px solid transparent;

		&.active, &:hover {
			color: #EF8200;
			border-bottom: 1px solid #707070;
		}
	`,
  DropArrow: styled.img`
		width: 9px;
		margin: 5px 8.5px;
		transition: ease 1s;
	`,
  TocSubTitleWrapper: styled.div`
		max-height: 0px;
		overflow: hidden;
		transition: ease 0.2s;

		&.active {
			max-height: 100px;
		}
	`,
  TocSubTitle: styled.div`
		font: 18px/32px Noto Sans TC;
		letter-spacing: 0.29px;
		color: #575757;
		margin-left: 40.5px;
		cursor: pointer;

		&:hover, &.active {
			color: #EF8200;
		}
	`
};

export const S = {
  ...otherS,
  TocWrapper: styled.div`
		&:hover {
			${otherS.TocSubTitleWrapper} {
				max-height: 100px;
			}

			${otherS.DropArrow} {
				transform: 'rotate(180deg);
			}
		}
	`
}
